import { useState, useEffect } from 'react';
import { Box, Callout, Dialog, Flex, Inset, Progress, Spinner } from '@radix-ui/themes';
import { Icon } from '@cloudscape-design/components';
import { SESSION_PHASE } from '../util/constants';

interface StatusMessagesProps {
  sessionPhase?: string | null;
  saveError?: string | null;
  alert?: Array<string> | null;
}

const FeedbackDialog = () => {
  const messages = [
    'Gathering feedback...',
    'Analyzing feedback...',
    'Preparing feedback report...',
  ]
  const [statusMsg, setStatusMsg] = useState(messages[0]);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    let currentIndex = 0;

    const interval = setInterval(() => {
      currentIndex = (currentIndex + 1) % messages.length;
      setStatusMsg(messages[currentIndex]);
    }, 8000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Dialog.Root defaultOpen={true} onOpenChange={(open) => setModalOpen(open)}>
      <Dialog.Content
        // Uncomment these lines to make the dialog not dismissable
        // onPointerDownOutside={(e) => {e.preventDefault()}}
        // onInteractOutside={(e) => {e.preventDefault()}}
      >
        <Inset>
          <Callout.Root variant="surface" size="3">
            <Callout.Icon>
              <Spinner />
            </Callout.Icon>
            <Callout.Text>
              {statusMsg}
            </Callout.Text>
          </Callout.Root>
          <Progress duration="60s" mt="-2" />
        </Inset>
      </Dialog.Content>
    </Dialog.Root>
  )
}

export default function StatusMessages({
  sessionPhase,
  saveError = null,
  alert = null,
}: StatusMessagesProps) {
  return (
    <Flex direction="column" align="center">
      <Flex direction="column" gap="3" style={{ backgroundColor: '#fff', borderRadius: 'var(--radius-4)' }}>
        {alert !== null && alert.length > 0 &&
          <Callout.Root color="yellow" variant="surface">
            <Callout.Icon>
              <Icon name="status-warning" />
            </Callout.Icon>
            <Callout.Text>
              {alert}
            </Callout.Text>
          </Callout.Root>
        }
        {/* {sessionPhase === SESSION_PHASE.SAVING_CONVERSATION && (
          <Callout.Root variant="surface">
            <Callout.Icon>
              <Spinner />
            </Callout.Icon>
            <Callout.Text>
              Saving Conversation...
            </Callout.Text>
          </Callout.Root>
        )} */}
        {sessionPhase === SESSION_PHASE.GETTING_FEEDBACK && (
          <FeedbackDialog />
        )}
        {/* {sessionPhase === SESSION_PHASE.GETTING_FEEDBACK && (
          <Callout.Root variant="surface">
            <Callout.Icon>
              <Spinner />
            </Callout.Icon>
            <Callout.Text>
              Getting Feedback in the background...
            </Callout.Text>
          </Callout.Root>
        )} */}
        {saveError && (
          <Callout.Root color="red" variant="surface">
            <Callout.Icon>
              <Icon name="status-negative" />
            </Callout.Icon>
            <Callout.Text>
              {saveError}
            </Callout.Text>
          </Callout.Root>
        )}
      </Flex>
    </Flex>
  )
}